import { cn } from "../../app/components/primitives/utils";
import { useFetchedFile, type FetchFile } from "./useFetchedFile";

// One page of the customer's file, as the family pictured it (JPEG, served by the page's own routes). It is fetched
// through the adapter, which sends the chosen customer, and shown from an object URL: an `<img src>` pointed at the
// route would be refused for a person with several customers. A page with no picture, or one that does not load,
// shows its number: the tag menu beneath it is the same either way.
export function PagePicture({
  url,
  fetchFile,
  pageNo,
  className,
}: {
  /** The picture's API-relative address; null for a page with none. */
  url: string | null;
  /** Null on a read-only page, where the pictures are numbers only. */
  fetchFile: FetchFile | null;
  pageNo: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex aspect-[3/4] items-center justify-center overflow-hidden rounded border bg-muted",
        className,
      )}
    >
      {url && fetchFile ? (
        <FetchedPicture url={url} fetchFile={fetchFile} pageNo={pageNo} />
      ) : (
        <PageNumber pageNo={pageNo} />
      )}
    </div>
  );
}

function FetchedPicture({
  url,
  fetchFile,
  pageNo,
}: {
  url: string;
  fetchFile: FetchFile;
  pageNo: number;
}) {
  const { state } = useFetchedFile(fetchFile, url);
  return state.status === "ready" ? (
    <img
      src={state.objectUrl}
      alt={`Page ${pageNo}`}
      className="size-full object-contain"
    />
  ) : (
    <PageNumber pageNo={pageNo} />
  );
}

function PageNumber({ pageNo }: { pageNo: number }) {
  return (
    <span
      aria-hidden
      className="text-2xl font-medium tabular-nums text-muted-foreground"
    >
      {pageNo}
    </span>
  );
}
